/* istanbul ignore file */
import { FormFieldsData } from 'framework/form';
import { TextField, useFieldHelper } from 'framework/ui/field';
import { getHumanReadableDataSize } from 'framework/utils';

type ArtifactStorageSizeFieldProps = {
  label: string;
  source: string;
  isVisible?: boolean | ((values: FormFieldsData) => boolean);
};

const ArtifactStorageSizeField = ({ source, ...props }: ArtifactStorageSizeFieldProps) => {
  const { getValue } = useFieldHelper({ source });

  return <TextField {...props} source={source} value={getHumanReadableDataSize(getValue())} />;
};

export default ArtifactStorageSizeField;
